const removeSelf = () => {
  document.querySelectorAll('[data-uss-close-self]').forEach((el) => {
    if (el.dataset.ussCloseSelf === 'true' || el.dataset.ussCloseSelf === '') {
      el.addEventListener('click', () => el.remove());
    }
  });
};

const wrap = (toWrap, wrapper) => {
  const arrayToWrap = toWrap.length ? toWrap : [toWrap];
  for (let i = 0, l = arrayToWrap.length; i < l; i += 1) {
    wrapper.appendChild(arrayToWrap[i]);
  }
  return wrapper;
};

const removeTarget = () => {
  document.querySelectorAll('[data-uss-close-target]').forEach((el) => {
    const target = document.querySelector(el.dataset.ussCloseTarget);
    if (target) {
      el.addEventListener('click', () => target.remove());
    }
  });
};

export { removeSelf, removeTarget, wrap };
